import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Colors from '../../../../layout/theme/utils/colors';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    marginBottom: {
      marginBottom: theme.spacing(1),
    },
    marginTop: {
      marginTop: theme.spacing(3),
    },
    boldText: {
      fontWeight: 'bold',
    },
    divider: {
      color: Colors.light_gray,
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
    },
  }),
);
